// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-quiz-container {
  width:100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.public-quiz-top-panel {
  background-color: rgba(247, 232, 186, 0.397);
  max-width: 100%;
  width: 100%;
  padding: 10px;
}

.public-quiz-question-count {
  margin-top: 20px;
  font-size: small;
  font-weight: bold;
}

.public-quiz-question-text {
  margin-top: 20px;
  font-size: xx-large;
  font-weight: bold;
  padding: 5px;
}

.public-quiz-answer-section {
  padding-top: 10px;
  flex:2 1;
  display: flex;
  /* justify-content: center; */
  flex-direction: column;
  align-items: center;
}

.public-quiz-answer-section-button {
  width: 90%;
  margin: 5px 0;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  border-radius: 10px;
}

.public-quiz-answer-section-button.correct {
  background-color: yellowgreen;
}

.public-quiz-answer-section-button.incorrect {
  background-color: rgb(205, 99, 50);
}

.public-quiz-front-back-button-row {
  display: flex;
  gap: 10px;
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Games/Quiz/PublicQuiz/PublicQuiz.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,QAAM;EACN,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf","sourcesContent":[".public-quiz-container {\n  width:100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.public-quiz-top-panel {\n  background-color: rgba(247, 232, 186, 0.397);\n  max-width: 100%;\n  width: 100%;\n  padding: 10px;\n}\n\n.public-quiz-question-count {\n  margin-top: 20px;\n  font-size: small;\n  font-weight: bold;\n}\n\n.public-quiz-question-text {\n  margin-top: 20px;\n  font-size: xx-large;\n  font-weight: bold;\n  padding: 5px;\n}\n\n.public-quiz-answer-section {\n  padding-top: 10px;\n  flex:2;\n  display: flex;\n  /* justify-content: center; */\n  flex-direction: column;\n  align-items: center;\n}\n\n.public-quiz-answer-section-button {\n  width: 90%;\n  margin: 5px 0;\n  padding: 10px;\n  font-size: 16px;\n  cursor: pointer;\n  border: 1px solid #ddd;\n  background-color: #f9f9f9;\n  border-radius: 10px;\n}\n\n.public-quiz-answer-section-button.correct {\n  background-color: yellowgreen;\n}\n\n.public-quiz-answer-section-button.incorrect {\n  background-color: rgb(205, 99, 50);\n}\n\n.public-quiz-front-back-button-row {\n  display: flex;\n  gap: 10px;\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
